// Module
var code = "<div wt-popover template=\"userPopover.html\" item=\"vm.user\" class=\"user-popover\" ng-if=\"vm.user.displayName\"> <span class=\"user-popover-name\">{{vm.user.displayName}}</span> </div> <div class=\"user-popover\" ng-if=\"!vm.user.displayName\"> <span class=\"user-popover-name\">&nbsp;</span> </div>";
// Exports
module.exports = code;